/* tslint:disable:indent */
import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {StringFunctions} from '../functions/string-functions';
import {API_ENDPOINTS} from '../api/api-endpoints';
import {WhmcsClient, WhmcsClientDetails} from '../models/whmcs-client.model';
import {WhmcsStats} from '../models/whmcs-stats.model';
import {StripePayout} from '../models/stripe.model';

@Injectable({providedIn: 'root'})
export class StripeService {
	getPendingPayouts(): Observable<StripePayout[]> {
		return this.http.post(
			API_ENDPOINTS.FINANCIAL.STRIPE_PAYOUTS,
			{ }
			)
			.pipe(
				map((response: any) => {
					if (!response.error) {
						return this.toStripePayoutsArray(response.message);
					} else {
						return [];
					}
				})
			);
	}

	private toStripePayoutsArray(data): StripePayout[] {
		const payouts: StripePayout[] = [];
		for (const item of data) {
			payouts.push(
				new StripePayout(
					parseInt(item.amount, 10) / 100,
					StringFunctions.emptyToNull(item.currency)
				)
			);
		}
		return payouts;
	}

	constructor(private http: HttpClient) { }
}
